import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  // Two columns, not the three-column grid TemplateForm uses (§6.2): a category
  // key and a display name are long enough that thirds would wrap them.
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  switches: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  submit: {
    marginTop: theme.spacing(2)
  }
}))
